import { NOTIFICATION_CONFIG, OEM_PORTAL, SUPPORT_PORTAL } from '../molecules/Notifications/Constants';
import { isEmpty } from './helper';
import { commentTimeStamp } from './helper.datetime';

/**
 * convert list of notifications payload from support portal  into notifications list
 * @param  {[type]} notifications array
 * @return {[type]}  array
 */
export const notificationFromSPPayload = notifications => {
  if (isEmpty(notifications)) return [];
  const notificationItems = notifications.map(notification => getNotificationObject(notification));
  return notificationItems;
};

/**
 * convert single notification  into notification item
 * @param  {[type]} notification object
 * @return {[type]}  object
 */
export const getNotificationObject = notification => {
  if (isEmpty(notification)) return {};
  const {
    ticket_details: ticketDetails,
    user_type: userType,
    event_type: eventType,
    message,
    body,
    created_at: timeStamp,
    ticket_id: itemId,
    bulk_update_id: bulkUpdateId,
    id,
    read: isRead
  } = notification;
  const {
    subject,
    brand_name: tagName
  } = ticketDetails;
  const idToReplace = eventType === 'ticket_bulk_update' ? bulkUpdateId : itemId;
  const formattedTime = commentTimeStamp(timeStamp);
  return {
    userType,
    eventType,
    message,
    body,
    subject,
    timeStamp: formattedTime,
    tagName,
    idToReplace,
    isRead,
    id
  };
};

/**
 * @description Function to get active tab initially on 'Notifications' drawer
 * @returns {String} - initial active tab for 'Notifications' drawer
 */
export const getActiveTab = () => {
  return window.location.pathname.split('/')[1] === 'oem' ? OEM_PORTAL.NAME : SUPPORT_PORTAL.NAME;
};

/**
 * @description Function to get module tabs for 'Notifications' drawer
 * @param {Boolean} isPartnerSite - boolean to distinguish between internal and external sites
 * @returns {Array} - module tabs for 'Notifications' drawer
 */
export const getTabsForNotifications = isPartnerSite => {
  return Object.keys(NOTIFICATION_CONFIG).filter(module => NOTIFICATION_CONFIG[module].isPartnerSite === isPartnerSite);
};